import React from 'react';
import Layout from '../components/layout';
import classes from '../styles/privacypolicy.module.css';

const PrivacyPolicy = () => {

    return (
        <Layout>
            <div className={classes.privacy_section}>
                <div className={classes.heading}>
                    <div className={classes.container}>
                        <h1>Privacy Policy</h1>
                    </div>
                </div>
                <div className={classes.overview}>
                    <div className={classes.container}>
                        <h3>
                            Some of the best app features;
                        </h3>
                        <div className={classes.content}>
                            <h5>Simple platform</h5>
                            <p>Sketshare provides a very simple, yet bold platform for your team’s collaboration on real-time</p>
                            <h5>Easy communication</h5>
                            <p>Sketshare ensures streamlined voice and video communication between team members on the platform </p>
                            <h5>Collaborate on real-time</h5>
                            <p>Sketshare provides real-time communication during the meeting session where everyone can see, comment and interact on the spot</p>
                            <h5>Build your story</h5>
                            <p>Sketshare has a unique layering feature where users can insert layers on top of each other to distinguish between the different team members ideas</p>
                            <h5>On all devices</h5>
                            <p>You can benefit from Sketshare wherever you are and from any device, your mobile, tablet or laptop. We built our technology to ensure you are synchronized between the different devices.</p>
                            <h5>For everyone</h5>
                            <p>With Sketshare, everyone from any profession can utilize the platform to their needs. You can work with your colleagues, study with your classmates or have fun with your friends </p>
                        </div>
                        <div className={classes.working}>
                            <h3>How it works:</h3>
                            <div className={classes.content}>
                                <h5>Step 01:</h5>
                                <p>Download Sketshare on all app stores for free or open the web-app version on your laptop.</p>
                                <h5>Step 02:</h5>
                                <p>You can create your account using your google, Facebook or apple ID or by simply giving a username and password. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default PrivacyPolicy;